import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// 커스텀 텍스트 유틸리티 클래스들을 tailwind-merge에 등록
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // 커스텀 typography 클래스들 (text-sys-* 색상과 충돌하지 않도록)
      'font-size': [
        {
          text: [
            'title-xlarge',
            'title-large',
            'title-medium',
            'title-small',
            'title-xsmall',
            'body-large',
            'body-medium',
            'body-small',
            'body-xsmall',
            'caption-large',
            'caption-medium',
            'caption-small',
            'caption-xsmall',
            'comp-accent-large',
            'comp-accent-medium',
            'comp-accent-small',
            'comp-accent-xsmall',
            'comp-moderate-large',
            'comp-moderate-medium',
            'comp-moderate-small',
            'comp-moderate-xsmall',
            'display-large',
            'display-medium',
            'display-small',
            'headline-large',
            'headline-medium',
            'headline-small',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
